<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell small-8 medium-6">
      <svg width="200" height="200" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <polygon [attr.points]="'0,80 ' + roofPitchPosition + ',' + (50 - (50 * (sliderPercentage / 100))) + ' 100,80'" class="roof"/>
        <rect y="81" x="0" width="100" height="19" class="house"/>
        <rect x="10" y="91" width="30" height="10" fill="white"/>
        <rect x="60" y="91" width="30" height="10" fill="white"/>
      </svg>
    </div>
    <div class="cell small-4 medium-6">
      <div class="slider-wrapper" >
        <div class="vertical-slider">
          <div class="slider-bar" #sliderbar>
            <div
              #sliderbarActive
              class="slider-bar-active"
              [style.height.%]="sliderPercentage"
            ></div>
          </div>
          <div #sliderthumb
               class="slider-thumb round-knob"
               tabindex="0"
               role="slider"
               aria-orientation="vertical"
               [attr.aria-labelledby]="formModel.id + '_label'"
               [style.top.%]="100 - sliderPercentage"
               (mousedown)="dragStart($event)"
               (touchstart)="dragStart($event)"
               (touchmove)="onDrag($event)"
               (keydown.arrowUp)="onArrowUp($event)"
               (keydown.arrowDown)="onArrowDown($event)"
               [attr.aria-valuenow]="sliderValue"
               [attr.aria-valuemin]="min"
               [attr.aria-valuemax]="max"
               [attr.aria-valuetext]="sliderValue + '°'"
          >
            <i class="icon-arrow-straight"></i>
            <div class="slider-value">{{sliderValue}} °</div>
          </div>
        </div>
        <div class="show-for-medium slider-extralabel" [innerHTML]="(step + '.' + formModel.id + '.extralabel') | translate"></div>
      </div>
      <input type="hidden" [id]="formModel.id" [formControlName]="formModel.id" [value]="formModel.getValue()" [required]="formModel.isRequired()">
    </div>
    <div class="cell small-12">
      <p [innerHTML]="(step + '.' + formModel.id + '.hint') | translate"></p>
    </div>

  </div>
</ng-container>
